// libs
import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// stores
import useAccountStore from '@/stores/account';
import Routes from '@/constants/Routes';
import { ROLES } from '@local/typedefs/dist/common/userRoles';
// styles
import styles from './PermissionsWrapper.module.scss';
const PermissionsWrapper = ({ children }) => {
    const [authorized, setAuthorized] = useState(false);
    const location = useLocation();
    const permissions = useAccountStore((state) => state.loggedInAccountDetails.permissions);
    useEffect(() => {
        performPathAuthorisation();
    }, [location.pathname]);
    const performPathAuthorisation = () => {
        const path = location.pathname;
        let isAuthorised = false;
        switch (true) {
            // CAMPAIGN EDIT
            case !!matchPath(Routes.INSTAMART.CAMPAIGN_EDIT.replace('{0}', ':id'), path):
                isAuthorised = permissions.includes(ROLES.EDIT_CAMPAIGN);
                break;
            // CAMPAIGN CREATE
            case !!matchPath(Routes.INSTAMART.CAMPAIGN_CREATE.replace('{0}', ':id'), path):
                isAuthorised = permissions.includes(ROLES.CREATE_CAMPAIGN);
                break;
            // CAMPAIGN DETAILS
            case !!matchPath(Routes.INSTAMART.CAMPAIGN_DETAILS.replace('{0}', ':id'), path):
                isAuthorised = permissions.includes(ROLES.VIEW_CAMPAIGN_DETAILS);
                break;
            // CAMPAIGN LIST
            case !!matchPath(Routes.INSTAMART.CAMPAIGN_LIST, path):
                isAuthorised = permissions.includes(ROLES.SEARCH_CAMPAIGN);
                break;
            default:
                isAuthorised = true;
        }
        setAuthorized(isAuthorised);
    };
    return (React.createElement(React.Fragment, null, authorized ? (children) : (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.containerCenter },
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Med_Emphasis }, "You are not authorized to view this page"))))));
};
export default PermissionsWrapper;
